import { SxProps, Theme } from "@mui/material";
import { getContrastColor } from "theme/utils";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  card: {
    display: "flex",
    flexDirection: "row",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
      p: "calc(1 * var(--rhythm))",
      borderRadius: 0,
    },
  },

  controls: {
    flex: 1,
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      flex: "1 1 auto",
      width: "100%",
    },
  },

  checkbox: {
    flexDirection: "row",
    justifyContent: "space-between",
    height: "calc(2 * var(--rhythm))",
    mb: "calc(1.5 * var(--rhythm))",
  },

  label: {
    display: "flex",
    alignItems: "center",
    gap: "1ex",
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontWeight: "medium",
    },
  },

  slider: {
    px: "calc(1 * var(--rhythm))",
  },

  box: {
    width: "140px",
    height: "calc(4.5 * var(--rhythm))",
    ml: "calc(1 * var(--rhythm))",
    px: "calc(1.5 * var(--rhythm))",
    py: "calc(0.5 * var(--rhythm))",
    borderLeft: "1px solid var(--color-border)",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "calc(2.5 * var(--rhythm))",
      m: "calc(1.5 * var(--rhythm)) 0 0 0",
      p: 0,
      borderRadius: "10px",
      borderLeft: "none",
    },
  },

  info: {
    flexDirection: "column",
    p: "calc(0 * var(--rhythm))",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      height: "calc(2.5 * var(--rhythm))",
      px: "var(--rhythm)",
      background: "var(--color-background)",
    },
  },

  step: {
    mt: "calc(1.5 * var(--rhythm))",
    fontWeight: "bold",
    color: "var(--color-grey)",
    [theme.breakpoints.down("md")]: {
      m: 0,
    },
  },

  steps: {
    ".RlxNumberField-label": {
      justifyContent: "center",
      color: getContrastColor(),
      "&.Mui-focused": {
        color: getContrastColor(),
      },
    },
    ".RlxNumberField-input": {
      fontWeight: "bold",
      color: getContrastColor(),
      background: "transparent",
      "&:hover": {
        background: "transparent",
      },
    },
    ".RlxNumberField-adornment": {
      background: getContrastColor(),
      "&:hover": {
        background: getContrastColor(),
      },
    },
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      height: "calc(2.5 * var(--rhythm))",
      margin: 0,
      padding: "0 var(--rhythm)",
      "&.RlxNumberField .RlxNumberField-label": {
        mb: 0,
      },
      "&.RlxNumberField .RlxNumberField-input": {
        height: "auto",
      },
    },
  },
});
